<template>
  <div id="app" class="clearfix">
    <headbanner />
    <div class="nav">
      <div class="auto">
        <ul class="tipsNav">
          <li class="on">
            <a href="#A1" @click="goAnchor">生态达人</a>
          </li>
          <li>
            <a href="#A2">观鸟视频日记</a>
          </li>
          <li>
            <a href="#A3">活动花絮</a>
          </li>
          <li>
            <a href="#A4">器材推荐</a>
          </li>
        </ul>
      </div>
    </div>
    <daren id="A1" v-if="dis" />
    <videoitem id="A2" v-if="dis" />
    <tidbits id="A3" v-if="dis" />
    <recommend id="A4" v-if="dis" />
    <fnton v-if="dis" />
  </div>
</template>

<script>
$(function() {
  $(".tipsNav li a").click(function(e) {
    e.preventDefault();
    $("html, body").animate({ scrollTop: $(this.hash).offset().top }, 400);
    $(this)
      .parent()
      .addClass("on")
      .siblings("li")
      .removeClass("on");
  });
});

import headbanner from "./components/headBanner";
import daren from "./components/daren";
import videoitem from "./components/videoitem";
import tidbits from "./components/tidbits";
import recommend from "./components/recommend";
import fnton from "./components/fnton";
export default {
  name: "app",
  data() {
    return {
      dis: false
    };
  },
  components: {
    headbanner,
    daren,
    videoitem,
    tidbits,
    recommend,
    fnton
  },
  created() {
    setTimeout(() => {
      this.dis = true;
    }, 1000);
  },
  methods: {
    goAnchor() {}
  }
};
</script>

<style scoped>
@import url(./assets/css/index.css);
#app {
  margin: 0 auto;
  width: 100%;
  min-width: 1300px;
  max-width: 1920px;
  overflow: hidden;
}
.nav {
  float: left;
  margin-top: 58px;
  margin-bottom: 50px;
  width: 100%;
  height: 75px;
}
.auto {
  margin: 0 auto;
  width: 1190px;
  height: 75px;
}
.auto ul {
  float: left;
  width: 1190px;
  height: 75px;
}
.auto ul li {
  float: left;
  cursor: pointer;
  margin-right: 2px;
  width: 295px;
  height: 75px;
  line-height: 75px;
  background: #ededee;
  font-size: 26px;
  color: #000;
  text-align: center;
}
.auto ul li a {
  float: left;
  display: block;
  width: 100%;
  height: 75px;
  line-height: 75px;
  text-align: center;
  text-decoration: none;
  color: #000;
  font-family: siyuan2;
}
.auto ul li.on {
  background: #85c023;
  color: #fff;
}
.auto ul li.on a {
  color: #fff;
}
.auto ul li:first-child {
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
}
.auto ul li:last-child {
  margin: 0;
  border-top-right-radius: 50px;
  border-bottom-right-radius: 50px;
}
</style>
